import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fbedd4;
  padding: 8px 20px;
  border-radius: 12px;
  gap: 8px;
  position: relative;
`;

export const IconContainer = styled.div`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const InfoButton = styled.button`
  width: 16px;
  height: 16px;
  cursor: pointer;
  color: #757575;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  svg {
    width: 100%;
    height: 100%;
  }

  &:focus {
    outline: 2px solid #4a90e2;
    outline-offset: 2px;
    border-radius: 2px;
  }
`;

export const TooltipContainer = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background-color: #000000;
  color: #ffffff;
  border-radius: 4px;
  padding: 8px;
  box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  max-width: 300px;
  white-space: nowrap;
  word-wrap: break-word;

  /* Tooltip caret pointing up */
  &::before {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 9px solid transparent;
    border-right: 9px solid transparent;
    border-bottom: 9px solid #000000;
  }
`;

export const TitleText = styled.div`
  color: #000000;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  text-align: left;
`;

export const TooltipText = styled.div`
  color: #ffffff;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.43;
`;
